import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { Card, CardHeader, CardContent, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Alert, AlertDescription } from '../components/ui/alert';
import { Badge } from '../components/ui/badge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolderOpen } from '@fortawesome/free-solid-svg-icons';
import { ExternalLinkIcon, CheckIcon, CopyIcon, BookmarkIcon, ChromeIcon, MailIcon, SparklesIcon, CodeIcon, GlobeIcon } from 'lucide-react';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL !== undefined ? process.env.REACT_APP_BACKEND_URL : 'http://localhost:8001';
const FRONTEND_URL = process.env.REACT_APP_BACKEND_URL ? process.env.REACT_APP_BACKEND_URL.replace(/:\d+$/, '') : 'http://localhost:3000';

// Bookmarklet 2 Modal - BRAND NEW MODAL to avoid any caching
function Bookmarklet2Modal({ userId, userEmail, apiUrl, onClose }) {
  const buttonRef = useRef(null);
  
  // EXACT SAME bookmarklet code as folder icon
  const bookmarkletCode = `javascript:(function(){if(window.ticklerModal){return;}var userId='${userId}';var s=document.createElement('style');s.innerHTML='@keyframes tSlide{0%{transform:translate(-50%,-100%);opacity:0}100%{transform:translate(-50%,0);opacity:1}}@keyframes tFade{from{opacity:0}to{opacity:1}}@keyframes tSpin{to{transform:rotate(360deg)}}';document.head.appendChild(s);var o=document.createElement('div');o.style.cssText='position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.5);z-index:999998;animation:tFade 0.3s;backdrop-filter:blur(4px)';var m=document.createElement('div');m.id='tickler-modal';window.ticklerModal=m;m.style.cssText='position:fixed;top:20px;left:50%;transform:translateX(-50%);max-width:420px;width:90%;background:white;border-radius:12px;box-shadow:0 1px 3px rgba(0,0,0,0.1),0 1px 2px rgba(0,0,0,0.06);z-index:999999;animation:tSlide 0.5s ease-out;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif;border:1px solid rgb(226,232,240)';m.innerHTML='<div style="padding:24px"><div style="display:flex;align-items:center;gap:8px;margin-bottom:16px"><svg style="width:20px;height:20px;color:rgb(249,115,22)" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"/></svg><h3 style="margin:0;font-size:18px;font-weight:700;color:rgb(15,23,42)">Save to Tickler</h3></div><p style="margin:0 0 20px;font-size:14px;color:rgb(100,116,139)">Choose where to save this content:</p><div style="display:flex;gap:12px"><button id="t-idea" style="flex:1;display:flex;align-items:center;justify-content:center;gap:6px;padding:10px 16px;border-radius:8px;font-size:14px;font-weight:500;transition:all 0.15s;background:white;color:rgb(234,88,12);border:2px solid rgb(251,146,60);cursor:pointer"><svg style="width:16px;height:16px" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/></svg>Idea</button><button id="t-lib" style="flex:1;display:flex;align-items:center;justify-content:center;gap:6px;padding:10px 16px;border-radius:8px;font-size:14px;font-weight:500;transition:all 0.15s;background:white;color:rgb(37,99,235);border:2px solid rgb(96,165,250);cursor:pointer"><svg style="width:16px;height:16px" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"/></svg>Library</button></div></div>';document.body.appendChild(o);document.body.appendChild(m);var ideaBtn=document.getElementById('t-idea');var libBtn=document.getElementById('t-lib');ideaBtn.onmouseover=function(){this.style.background='rgb(249,115,22)';this.style.color='white';this.style.borderColor='rgb(249,115,22)'};ideaBtn.onmouseout=function(){this.style.background='white';this.style.color='rgb(234,88,12)';this.style.borderColor='rgb(251,146,60)'};libBtn.onmouseover=function(){this.style.background='rgb(59,130,246)';this.style.color='white';this.style.borderColor='rgb(59,130,246)'};libBtn.onmouseout=function(){this.style.background='white';this.style.color='rgb(37,99,235)';this.style.borderColor='rgb(96,165,250)'};function close(){o.remove();m.remove();window.ticklerModal=null}o.onclick=close;function toast(msg,ok){close();var t=document.createElement('div');t.style.cssText='position:fixed;top:20px;right:20px;background:'+(ok?'rgb(34,197,94)':'rgb(239,68,68)')+';color:white;padding:12px 20px;border-radius:8px;box-shadow:0 4px 6px rgba(0,0,0,0.1);font-size:14px;font-weight:600;z-index:999999;animation:tSlide 0.3s;display:flex;align-items:center;gap:8px';var icon=document.createElement('span');icon.textContent=ok?'✓':'✗';icon.style.cssText='font-size:18px';t.appendChild(icon);var txt=document.createElement('span');txt.textContent=msg;t.appendChild(txt);document.body.appendChild(t);setTimeout(function(){t.style.transition='opacity 0.3s';t.style.opacity='0';setTimeout(function(){t.remove()},300)},3000)}function save(c){m.innerHTML='<div style="padding:48px 24px;text-align:center"><div style="width:40px;height:40px;margin:0 auto 16px;border:3px solid rgb(226,232,240);border-top-color:rgb(59,130,246);border-radius:50%;animation:tSpin 0.8s linear infinite"></div><p style="margin:0;color:rgb(100,116,139);font-size:14px;font-weight:500">Saving to Tickler...</p></div>';var txt=(document.body.innerText||'').substring(0,5000);var art=document.querySelector('article')||document.querySelector('main')||document.body;var html=(art.innerHTML||'').substring(0,50000);var tick=(txt.match(/\\$[A-Z]{1,5}\\b/g)||[]).join(',');fetch('${apiUrl}/api/inbound-email',{method:'POST',headers:{'Content-Type':'application/json','X-Tickler-User-ID':userId,'X-Tickler-Source':'bookmarklet'},body:JSON.stringify({From:'${userEmail}',Subject:document.title,'stripped-text':txt,'stripped-html':html,url:location.href,tickers:tick,classification:c})}).then(function(r){if(!r.ok)throw new Error('Failed');return r.json()}).then(function(){toast(c==='idea'?'Saved as Idea!':'Saved as Library!',true)}).catch(function(){toast('Error saving',false)})}ideaBtn.onclick=function(){save('idea')};libBtn.onclick=function(){save('library')}})();`;

  useEffect(() => {
    if (!buttonRef.current) return;
    
    const container = buttonRef.current;
    container.innerHTML = '';
    
    const link = document.createElement('a');
    link.href = bookmarkletCode;
    link.textContent = '💚 Save to Tickler V2';
    link.draggable = true;
    link.className = 'inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-green-500 to-green-600 text-white font-bold text-lg rounded-xl shadow-lg hover:shadow-xl transition-all cursor-move';
    link.onclick = (e) => {
      e.preventDefault();
      alert('Drag this GREEN button to your bookmarks bar!');
    };
    
    container.appendChild(link);
  }, [bookmarkletCode]);

  return (
    <div 
      className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div 
        className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl p-8 border-4 border-green-500"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-bold text-green-600">💚 Bookmarklet V2 (Fresh)</h2>
          <button
            onClick={onClose}
            className="text-slate-400 hover:text-slate-600 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="space-y-6">
          <div className="p-6 bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl border-2 border-green-400">
            <p className="text-slate-700 font-medium text-center mb-4">
              ↓ Drag this GREEN button to your bookmarks bar ↓
            </p>
            <div className="flex justify-center" ref={buttonRef}>
              {/* Button created via vanilla JS */}
            </div>
          </div>

          <div className="p-4 bg-green-50 rounded-lg border border-green-200">
            <h3 className="font-semibold text-slate-900 mb-2">How to use:</h3>
            <ol className="text-sm text-slate-700 space-y-1 list-decimal list-inside">
              <li>Drag the GREEN button above to your bookmarks bar</li>
              <li>Visit any webpage and click it</li>
              <li>Choose "Idea" or "Library" in the modal</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
}

// OLD Bookmarklet Modal - Shows NEW button to test cache issue
function BookmarkletModal({ userId, userEmail, apiUrl, onClose }) {
  const newButtonRef = useRef(null);
  
  // EXACT SAME bookmarklet code as folder icon - not changing functionality AT ALL
  const bookmarkletCode = `javascript:(function(){if(window.ticklerModal){return;}var userId='${userId}';var s=document.createElement('style');s.innerHTML='@keyframes tSlide{0%{transform:translate(-50%,-100%);opacity:0}100%{transform:translate(-50%,0);opacity:1}}@keyframes tFade{from{opacity:0}to{opacity:1}}@keyframes tSpin{to{transform:rotate(360deg)}}';document.head.appendChild(s);var o=document.createElement('div');o.style.cssText='position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.5);z-index:999998;animation:tFade 0.3s;backdrop-filter:blur(4px)';var m=document.createElement('div');m.id='tickler-modal';window.ticklerModal=m;m.style.cssText='position:fixed;top:20px;left:50%;transform:translateX(-50%);max-width:420px;width:90%;background:white;border-radius:12px;box-shadow:0 1px 3px rgba(0,0,0,0.1),0 1px 2px rgba(0,0,0,0.06);z-index:999999;animation:tSlide 0.5s ease-out;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif;border:1px solid rgb(226,232,240)';m.innerHTML='<div style="padding:24px"><div style="display:flex;align-items:center;gap:8px;margin-bottom:16px"><svg style="width:20px;height:20px;color:rgb(249,115,22)" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"/></svg><h3 style="margin:0;font-size:18px;font-weight:700;color:rgb(15,23,42)">Save to Tickler</h3></div><p style="margin:0 0 20px;font-size:14px;color:rgb(100,116,139)">Choose where to save this content:</p><div style="display:flex;gap:12px"><button id="t-idea" style="flex:1;display:flex;align-items:center;justify-content:center;gap:6px;padding:10px 16px;border-radius:8px;font-size:14px;font-weight:500;transition:all 0.15s;background:white;color:rgb(234,88,12);border:2px solid rgb(251,146,60);cursor:pointer"><svg style="width:16px;height:16px" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/></svg>Idea</button><button id="t-lib" style="flex:1;display:flex;align-items:center;justify-content:center;gap:6px;padding:10px 16px;border-radius:8px;font-size:14px;font-weight:500;transition:all 0.15s;background:white;color:rgb(37,99,235);border:2px solid rgb(96,165,250);cursor:pointer"><svg style="width:16px;height:16px" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"/></svg>Library</button></div></div>';document.body.appendChild(o);document.body.appendChild(m);var ideaBtn=document.getElementById('t-idea');var libBtn=document.getElementById('t-lib');ideaBtn.onmouseover=function(){this.style.background='rgb(249,115,22)';this.style.color='white';this.style.borderColor='rgb(249,115,22)'};ideaBtn.onmouseout=function(){this.style.background='white';this.style.color='rgb(234,88,12)';this.style.borderColor='rgb(251,146,60)'};libBtn.onmouseover=function(){this.style.background='rgb(59,130,246)';this.style.color='white';this.style.borderColor='rgb(59,130,246)'};libBtn.onmouseout=function(){this.style.background='white';this.style.color='rgb(37,99,235)';this.style.borderColor='rgb(96,165,250)'};function close(){o.remove();m.remove();window.ticklerModal=null}o.onclick=close;function toast(msg,ok){close();var t=document.createElement('div');t.style.cssText='position:fixed;top:20px;right:20px;background:'+(ok?'rgb(34,197,94)':'rgb(239,68,68)')+';color:white;padding:12px 20px;border-radius:8px;box-shadow:0 4px 6px rgba(0,0,0,0.1);font-size:14px;font-weight:600;z-index:999999;animation:tSlide 0.3s;display:flex;align-items:center;gap:8px';var icon=document.createElement('span');icon.textContent=ok?'✓':'✗';icon.style.cssText='font-size:18px';t.appendChild(icon);var txt=document.createElement('span');txt.textContent=msg;t.appendChild(txt);document.body.appendChild(t);setTimeout(function(){t.style.transition='opacity 0.3s';t.style.opacity='0';setTimeout(function(){t.remove()},300)},3000)}function save(c){m.innerHTML='<div style="padding:48px 24px;text-align:center"><div style="width:40px;height:40px;margin:0 auto 16px;border:3px solid rgb(226,232,240);border-top-color:rgb(59,130,246);border-radius:50%;animation:tSpin 0.8s linear infinite"></div><p style="margin:0;color:rgb(100,116,139);font-size:14px;font-weight:500">Saving to Tickler...</p></div>';var txt=(document.body.innerText||'').substring(0,5000);var art=document.querySelector('article')||document.querySelector('main')||document.body;var html=(art.innerHTML||'').substring(0,50000);var tick=(txt.match(/\\$[A-Z]{1,5}\\b/g)||[]).join(',');fetch('${apiUrl}/api/inbound-email',{method:'POST',headers:{'Content-Type':'application/json','X-Tickler-User-ID':userId,'X-Tickler-Source':'bookmarklet'},body:JSON.stringify({From:'${userEmail}',Subject:document.title,'stripped-text':txt,'stripped-html':html,url:location.href,tickers:tick,classification:c})}).then(function(r){if(!r.ok)throw new Error('Failed');return r.json()}).then(function(){toast(c==='idea'?'Saved as Idea!':'Saved as Library!',true)}).catch(function(){toast('Error saving',false)})}ideaBtn.onclick=function(){save('idea')};libBtn.onclick=function(){save('library')}})();`;

  // Create NEW button using vanilla JS to avoid any caching
  useEffect(() => {
    if (!newButtonRef.current) return;
    
    const container = newButtonRef.current;
    container.innerHTML = '';
    
    // Create link with vanilla JS
    const link = document.createElement('a');
    link.href = bookmarkletCode;
    link.textContent = '📥 Save to Tickler (NEW - NOT CACHED)';
    link.draggable = true;
    link.className = 'inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-green-500 to-green-600 text-white font-bold text-lg rounded-xl shadow-lg hover:shadow-xl transition-all cursor-move';
    link.onclick = (e) => {
      e.preventDefault();
      alert('Drag this NEW button to your bookmarks bar!');
    };
    
    container.appendChild(link);
  }, [bookmarkletCode]);

  return (
    <div 
      className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div 
        className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl p-8"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-bold text-slate-900">📥 Install Bookmarklet</h2>
          <button
            onClick={onClose}
            className="text-slate-400 hover:text-slate-600 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="space-y-6">
          <div className="p-6 bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl border-2 border-green-300">
            <h3 className="font-semibold text-slate-900 mb-4 text-center">🆕 NEW Bookmarklet Button (Test for Cache Issue)</h3>
            <p className="text-sm text-slate-600 mb-4 text-center">Same bookmarklet as folder icon, just marked NEW to avoid cache</p>
            
            <div className="flex justify-center" ref={newButtonRef}>
              {/* NEW button created via vanilla JS */}
            </div>
          </div>

          <div className="p-6 bg-blue-50 rounded-lg">
            <h3 className="font-semibold text-slate-900 mb-3">How to Install:</h3>
            <ol className="text-sm text-slate-700 space-y-2 list-decimal list-inside">
              <li><strong>Drag the GREEN button above</strong> to your bookmarks bar</li>
              <li>Visit any webpage and click it to save content</li>
              <li>Choose "Idea" or "Library" when the modal appears</li>
            </ol>
          </div>

          <div className="p-4 bg-amber-50 rounded-lg border border-amber-200">
            <p className="text-sm text-amber-800">
              <strong>Note:</strong> This is the EXACT SAME bookmarklet as the folder icon on the home page, just marked NEW to test if your issue is browser caching.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

function SaveMethodsPage() {
  const [copiedEmail, setCopiedEmail] = useState(false);
  const [copiedBookmarklet, setCopiedBookmarklet] = useState(false);
  const [copiedPublisherCode, setCopiedPublisherCode] = useState(false);
  const [user, setUser] = useState(null);
  const [showBookmarkletModal, setShowBookmarkletModal] = useState(false);
  const [showBookmarklet2Modal, setShowBookmarklet2Modal] = useState(false);
  const bookmarkletRef = useRef(null);

  // Get user from localStorage
  useEffect(() => {
    const userData = localStorage.getItem('tickler_user');
    if (userData) {
      try {
        setUser(JSON.parse(userData));
      } catch (e) {
        console.error('Error parsing user data:', e);
      }
    }
  }, []);

  // User's unique Tickler email address
  const userEmail = user?.email || 'demo@example.com';
  const userId = user?.id || 'demo-user';
  const ticklerEmail = `${userEmail.replace('@', '_at_')}@sandbox6099684e18ba4d7a984bcf8b928d45b0.mailgun.org`;
  
  // Publisher button embed code
  const publisherButtonCode = `<!-- Tickler Publisher Button -->
<script src="${API_BASE_URL}/tickler-publisher-button.js"></script>
<a href="#" class="tickler-save-button">Save to Tickler</a>`;

  // Bookmarklet using Mozilla Readability.js for clean article extraction
  // Uses Readability.js - Copyright (c) 2010 Arc90 Inc / Mozilla Foundation
  // Licensed under Apache License 2.0: https://www.apache.org/licenses/LICENSE-2.0
  const bookmarkletCode = `javascript:(function(){if(window.ticklerBookmarkletLoading){return;}window.ticklerBookmarkletLoading=true;var url=window.location.href;var title=document.title;var userEmail='${userEmail}';var userId='${userId}';var saveUrl='${FRONTEND_URL}/quick-save';var isTwitter=url.indexOf('twitter.com')>-1||url.indexOf('x.com')>-1;var isTweetUrl=url.indexOf('/status/')>-1;if(isTwitter){if(isTweetUrl){var redirectUrl=saveUrl+'?url='+encodeURIComponent(url)+'&title='+encodeURIComponent(title)+'&email='+encodeURIComponent(userEmail)+'&source=twitter';var popup=window.open(redirectUrl,'tickler_save','width=500,height=400');if(!popup||popup.closed||typeof popup.closed=='undefined'){alert('Please allow popups for this site to save Twitter/X posts');}window.ticklerBookmarkletLoading=false;return;}else{var toast=document.createElement('div');toast.style.cssText='position:fixed;top:20px;right:20px;background:#3b82f6;color:white;padding:16px 24px;border-radius:8px;box-shadow:0 4px 6px rgba(0,0,0,0.1);font-family:system-ui,-apple-system,sans-serif;font-size:14px;font-weight:500;z-index:999999;animation:slideIn 0.3s ease;';var style=document.createElement('style');style.textContent='@keyframes slideIn{from{transform:translateX(400px);opacity:0;}to{transform:translateX(0);opacity:1;}}';document.head.appendChild(style);toast.textContent='📱 Please open a specific tweet to save';document.body.appendChild(toast);setTimeout(function(){toast.style.transition='opacity 0.3s';toast.style.opacity='0';setTimeout(function(){if(toast.parentNode){document.body.removeChild(toast);}},300);},3000);window.ticklerBookmarkletLoading=false;return;}}var apiUrl='${API_BASE_URL}/api/inbound-email';var loadingToast=null;function showLoadingToast(){var toast=document.createElement('div');toast.id='tickler-loading-toast';toast.style.cssText='position:fixed;top:20px;right:20px;background:#667eea;color:white;padding:16px 24px;border-radius:8px;box-shadow:0 4px 6px rgba(0,0,0,0.1);font-family:system-ui,-apple-system,sans-serif;font-size:14px;font-weight:500;z-index:999999;animation:slideIn 0.3s ease;display:flex;align-items:center;gap:8px;';var style=document.createElement('style');style.textContent='@keyframes slideIn{from{transform:translateX(400px);opacity:0;}to{transform:translateX(0);opacity:1;}}@keyframes spin{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}';document.head.appendChild(style);var spinner=document.createElement('span');spinner.style.cssText='display:inline-block;width:14px;height:14px;border:2px solid rgba(255,255,255,0.3);border-top:2px solid white;border-radius:50%;animation:spin 0.8s linear infinite;';toast.appendChild(spinner);var text=document.createElement('span');text.textContent='Saving to Tickler...';toast.appendChild(text);document.body.appendChild(toast);loadingToast=toast;return toast;}function removeLoadingToast(){if(loadingToast&&loadingToast.parentNode){loadingToast.parentNode.removeChild(loadingToast);loadingToast=null;}}function showToast(msg,success){removeLoadingToast();var toast=document.createElement('div');toast.style.cssText='position:fixed;top:20px;right:20px;background:'+(success?'#10b981':'#ef4444')+';color:white;padding:16px 24px;border-radius:8px;box-shadow:0 4px 6px rgba(0,0,0,0.1);font-family:system-ui,-apple-system,sans-serif;font-size:14px;font-weight:500;z-index:999999;animation:slideIn 0.3s ease;display:flex;align-items:center;gap:8px;';var style=document.createElement('style');style.textContent='@keyframes slideIn{from{transform:translateX(400px);opacity:0;}to{transform:translateX(0);opacity:1;}}';document.head.appendChild(style);var icon=document.createElement('span');icon.textContent=success?'\\u2713':'\\u2715';icon.style.cssText='font-size:18px;font-weight:bold;';toast.appendChild(icon);var text=document.createElement('span');text.textContent=msg;toast.appendChild(text);document.body.appendChild(toast);setTimeout(function(){toast.style.transition='opacity 0.3s';toast.style.opacity='0';setTimeout(function(){if(toast.parentNode){document.body.removeChild(toast);}},300);},3000);}showLoadingToast();function fallbackCapture(){var bodyText=document.body.innerText||document.body.textContent;var cleanText=bodyText.substring(0,5000);var article=document.querySelector('article')||document.querySelector('main')||document.querySelector('[role=\"main\"]')||document.body;var cleanHTML=article.innerHTML||document.body.innerHTML;var tickers=(bodyText.match(/\\$[A-Z]{1,5}\\b/g)||[]).join(',');fetch(apiUrl,{method:'POST',headers:{'X-Tickler-Source':'bookmarklet','X-Tickler-User-ID':userId,'Content-Type':'application/json'},body:JSON.stringify({From:userEmail,Subject:title,'stripped-text':cleanText,'stripped-html':cleanHTML,url:url,tickers:tickers})}).then(function(r){return r.json();}).then(function(d){showToast('Saved to Tickler!',true);window.ticklerBookmarkletLoading=false;}).catch(function(e){showToast('Error: '+e.message,false);window.ticklerBookmarkletLoading=false;});}function loadReadability(callback){if(typeof Readability!=='undefined'){callback();return;}var script=document.createElement('script');script.src='https://cdn.jsdelivr.net/npm/@mozilla/readability@0.5.0/Readability.min.js';script.onload=callback;script.onerror=function(){fallbackCapture();};document.head.appendChild(script);}loadReadability(function(){try{var documentClone=document.cloneNode(true);var reader=new Readability(documentClone);var article=reader.parse();if(!article){fallbackCapture();return;}var cleanHTML=article.content;var cleanText=article.textContent.substring(0,5000);var tickers=(article.textContent.match(/\\$[A-Z]{1,5}\\b/g)||[]).join(',');fetch(apiUrl,{method:'POST',headers:{'X-Tickler-Source':'bookmarklet','X-Tickler-User-ID':userId,'Content-Type':'application/json'},body:JSON.stringify({From:userEmail,Subject:title,'stripped-text':cleanText,'stripped-html':cleanHTML,url:url,tickers:tickers})}).then(function(r){return r.json();}).then(function(d){showToast('Saved to Tickler!',true);window.ticklerBookmarkletLoading=false;}).catch(function(e){showToast('Error: '+e.message,false);window.ticklerBookmarkletLoading=false;});}catch(err){fallbackCapture();}});})();`;

  // Create bookmarklet link after component mounts (bypasses React's security)
  useEffect(() => {
    if (bookmarkletRef.current && bookmarkletCode) {
      const container = bookmarkletRef.current;
      
      // Clear any existing content
      container.innerHTML = '';
      
      // Create anchor element entirely via DOM (React never sees it)
      const link = document.createElement('a');
      // DON'T set href - React blocks it. We'll use drag data only.
      link.title = '📥 Save to Tickler';
      link.draggable = true;
      link.style.cssText = 'display: flex; align-items: center; width: 100%; height: 100%; text-decoration: none; color: inherit; cursor: move;';
      
      // Add content
      link.innerHTML = `
        <svg class="h-6 w-6 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"></path>
        </svg>
        Save to Tickler
        <div style="position: absolute; top: -4px; right: -4px; width: 16px; height: 16px; background-color: #4ade80; border-radius: 50%; animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;"></div>
      `;
      
      // Handle click - show instruction
      link.addEventListener('click', (e) => {
        e.preventDefault();
        alert('Please DRAG this button to your bookmarks bar to install!');
      });
      
      // Handle drag - THE CRITICAL PART - this creates the bookmark
      link.addEventListener('dragstart', (e) => {
        e.dataTransfer.effectAllowed = 'copy';
        // Set the bookmark URL and title via drag data
        e.dataTransfer.setData('text/uri-list', bookmarkletCode);
        e.dataTransfer.setData('text/plain', bookmarkletCode);
        e.dataTransfer.setData('text/x-moz-url', bookmarkletCode + '\n📥 Save to Tickler');
      });
      
      // Append to container
      container.appendChild(link);
    }
  }, [bookmarkletCode]);

  const copyToClipboard = (text, setStateFn) => {
    navigator.clipboard.writeText(text);
    setStateFn(true);
    setTimeout(() => setStateFn(false), 2000);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-50">
      {/* Modern Header */}
      <header className="bg-white/80 backdrop-blur-md border-b border-slate-200/50 shadow-sm sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-6 py-4">
          <div 
            className="flex items-center space-x-3 cursor-pointer hover:opacity-80 transition-opacity group"
            onClick={() => window.location.href = '/'}
          >
            <div className="bg-gradient-to-br from-slate-700 to-slate-800 p-2.5 rounded-xl shadow-lg group-hover:shadow-xl transition-all">
              <FontAwesomeIcon icon={faFolderOpen} className="h-6 w-6" style={{ color: '#F58346' }} />
            </div>
            <div>
              <h1 className="text-2xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent">
                TICK<span className="text-orange-500">L</span>ER
              </h1>
              <p className="text-xs sm:text-sm text-slate-600">IDEAS WORTH VETTING.</p>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-orange-100 text-orange-700 rounded-full text-sm font-medium mb-4">
            <SparklesIcon className="h-4 w-4" />
            Four Ways to Capture Ideas
          </div>
          <h2 className="text-4xl font-bold text-slate-900 mb-4">
            Save Investment Ideas from Anywhere
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Choose your preferred method to capture and organize investment opportunities on the web
          </p>
        </div>

        <Tabs defaultValue="bookmarklet" className="w-full">
          {/* Modern Tab List */}
          <TabsList className="grid w-full grid-cols-4 mb-8 bg-slate-100 p-1.5 rounded-2xl h-auto">
            <TabsTrigger 
              value="bookmarklet" 
              className="data-[state=active]:bg-white data-[state=active]:shadow-md rounded-xl py-3 px-4 transition-all"
            >
              <BookmarkIcon className="h-4 w-4 mr-2" />
              <span className="font-semibold">Bookmarklet</span>
            </TabsTrigger>
            <TabsTrigger 
              value="publisher"
              className="data-[state=active]:bg-white data-[state=active]:shadow-md rounded-xl py-3 px-4 transition-all"
            >
              <CodeIcon className="h-4 w-4 mr-2" />
              <span className="font-semibold">Publisher</span>
            </TabsTrigger>
            <TabsTrigger 
              value="extension"
              className="data-[state=active]:bg-white data-[state=active]:shadow-md rounded-xl py-3 px-4 transition-all"
            >
              <ChromeIcon className="h-4 w-4 mr-2" />
              <span className="font-semibold">Extension</span>
            </TabsTrigger>
            <TabsTrigger 
              value="email"
              className="data-[state=active]:bg-white data-[state=active]:shadow-md rounded-xl py-3 px-4 transition-all"
            >
              <MailIcon className="h-4 w-4 mr-2" />
              <span className="font-semibold">Email</span>
            </TabsTrigger>
          </TabsList>

          {/* Bookmarklet Tab */}
          <TabsContent value="bookmarklet">
            <Card className="border-0 shadow-xl bg-white/50 backdrop-blur">
              <CardHeader className="border-b border-slate-100 pb-6">
                <CardTitle className="flex items-center text-2xl">
                  <div className="bg-gradient-to-br from-orange-500 to-orange-600 p-2 rounded-lg mr-3">
                    <BookmarkIcon className="h-6 w-6 text-white" />
                  </div>
                  One-Click Bookmarklet
                </CardTitle>
                <p className="text-slate-600 mt-2">Works on all browsers • No installation required • Instant saves</p>
              </CardHeader>
              <CardContent className="space-y-8 pt-8">
                {/* Step 1 */}
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <div className="flex items-center justify-center w-8 h-8 rounded-full bg-orange-100 text-orange-600 font-bold text-sm">
                      1
                    </div>
                    <h3 className="text-lg font-semibold text-slate-900">Show Your Bookmarks Bar</h3>
                  </div>
                  <div className="ml-11 grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div className="p-4 bg-slate-50 rounded-xl border border-slate-200">
                      <p className="font-semibold text-slate-700 mb-2">Chrome / Edge</p>
                      <kbd className="px-3 py-1.5 bg-white rounded-lg border border-slate-300 text-sm font-mono">
                        ⌘ Shift B
                      </kbd>
                    </div>
                    <div className="p-4 bg-slate-50 rounded-xl border border-slate-200">
                      <p className="font-semibold text-slate-700 mb-2">Firefox</p>
                      <kbd className="px-3 py-1.5 bg-white rounded-lg border border-slate-300 text-sm font-mono">
                        Ctrl B
                      </kbd>
                    </div>
                    <div className="p-4 bg-slate-50 rounded-xl border border-slate-200">
                      <p className="font-semibold text-slate-700 mb-2">Safari</p>
                      <p className="text-sm text-slate-600">View → Show Favorites Bar</p>
                    </div>
                  </div>
                </div>

                {/* Step 2 - Drag Button from Modal */}
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <div className="flex items-center justify-center w-8 h-8 rounded-full bg-orange-100 text-orange-600 font-bold text-sm">
                      2
                    </div>
                    <h3 className="text-lg font-semibold text-slate-900">Install Your Bookmarklet</h3>
                  </div>
                  
                  <div className="ml-11 space-y-4">
                    <div className="p-6 bg-gradient-to-br from-orange-50 to-amber-50 rounded-xl border border-orange-200">
                      <p className="text-slate-700 mb-4">
                        Click the button below, then <strong>drag the orange button</strong> from the popup to your bookmarks bar.
                      </p>
                      <div className="flex gap-3">
                        <Button
                          onClick={() => setShowBookmarkletModal(true)}
                          className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-semibold rounded-lg shadow-lg transition-all"
                        >
                          <BookmarkIcon className="h-5 w-5" />
                          Install Bookmarklet
                        </Button>
                        
                        <Button
                          onClick={() => setShowBookmarklet2Modal(true)}
                          className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-semibold rounded-lg shadow-lg transition-all"
                        >
                          <BookmarkIcon className="h-5 w-5" />
                          Bookmarklet 2 (NEW)
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Step 3 */}
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <div className="flex items-center justify-center w-8 h-8 rounded-full bg-orange-100 text-orange-600 font-bold text-sm">
                      3
                    </div>
                    <h3 className="text-lg font-semibold text-slate-900">Start Saving!</h3>
                  </div>
                  <div className="ml-11 p-6 bg-blue-50 rounded-xl border border-blue-200">
                    <ol className="space-y-2 text-slate-700">
                      <li className="flex items-start">
                        <span className="text-blue-600 font-bold mr-3">→</span>
                        Visit any article or webpage about an investment idea
                      </li>
                      <li className="flex items-start">
                        <span className="text-blue-600 font-bold mr-3">→</span>
                        Click the "Save to Tickler" bookmark in your bar
                      </li>
                      <li className="flex items-start">
                        <span className="text-blue-600 font-bold mr-3">→</span>
                        See a confirmation toast – your idea is now saved!
                      </li>
                    </ol>
                  </div>
                </div>

                {/* Advanced Section */}
                <details className="ml-11 group">
                  <summary className="cursor-pointer text-slate-600 hover:text-slate-900 font-medium flex items-center gap-2">
                    <span>Advanced: Manual Setup</span>
                  </summary>
                  <div className="mt-4 p-4 bg-slate-50 rounded-xl border border-slate-200">
                    <p className="text-sm text-slate-600 mb-3">
                      Copy this code and create a bookmark manually:
                    </p>
                    <div className="relative">
                      <code className="block p-3 bg-slate-900 text-green-400 rounded-lg text-xs overflow-x-auto max-h-32 font-mono">
                        {bookmarkletCode}
                      </code>
                      <Button
                        size="sm"
                        variant="outline"
                        className="absolute top-2 right-2 bg-white"
                        onClick={() => copyToClipboard(bookmarkletCode, setCopiedBookmarklet)}
                      >
                        {copiedBookmarklet ? <CheckIcon className="h-4 w-4" /> : <CopyIcon className="h-4 w-4" />}
                      </Button>
                    </div>
                  </div>
                </details>
              </CardContent>
            </Card>
          </TabsContent>

          {/* Publisher Button Tab */}
          <TabsContent value="publisher">
            <Card className="border-0 shadow-xl bg-white/50 backdrop-blur">
              <CardHeader className="border-b border-slate-100 pb-6">
                <CardTitle className="flex items-center text-2xl">
                  <div className="bg-gradient-to-br from-orange-500 to-orange-600 p-2 rounded-lg mr-3">
                    <CodeIcon className="h-6 w-6 text-white" />
                  </div>
                  Publisher Button
                </CardTitle>
                <p className="text-slate-600 mt-2">For Substack, blogs, and websites • One-line embed • Like Pocket</p>
              </CardHeader>
              <CardContent className="space-y-8 pt-8">
                {/* Live Preview */}
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <div className="flex items-center justify-center w-8 h-8 rounded-full bg-orange-100 text-orange-600 font-bold text-sm">
                      👁️
                    </div>
                    <h3 className="text-lg font-semibold text-slate-900">Live Preview</h3>
                  </div>
                  
                  <div className="ml-11 p-8 bg-gradient-to-br from-slate-50 to-slate-100 rounded-2xl border-2 border-slate-200">
                    <div className="flex flex-col items-center gap-4">
                      <p className="text-slate-700 font-medium text-center">This is how the button will look on your site:</p>
                      
                      {/* Mock Publisher Button */}
                      <button
                        className="inline-flex items-center px-5 py-2.5 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl hover:scale-105 transition-all"
                        style={{ cursor: 'default' }}
                      >
                        <FontAwesomeIcon icon={faFolderOpen} className="mr-2" style={{ color: '#ffffff' }} />
                        Save to Tickler
                      </button>
                      
                      <p className="text-sm text-slate-500 text-center max-w-md">
                        Readers click this button to save your article to their Tickler account with AI analysis
                      </p>
                    </div>
                  </div>
                </div>

                {/* Step 1 - Copy Code */}
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <div className="flex items-center justify-center w-8 h-8 rounded-full bg-orange-100 text-orange-600 font-bold text-sm">
                      1
                    </div>
                    <h3 className="text-lg font-semibold text-slate-900">Copy the Embed Code</h3>
                  </div>
                  
                  <div className="ml-11 space-y-4">
                    <Alert className="border-orange-200 bg-orange-50">
                      <AlertDescription className="text-orange-900">
                        <strong>Simple integration:</strong> Just two lines of code to add the button anywhere on your site
                      </AlertDescription>
                    </Alert>
                    
                    <div className="relative">
                      <code className="block p-4 bg-slate-900 text-green-400 rounded-lg text-sm font-mono overflow-x-auto">
                        {publisherButtonCode}
                      </code>
                      <Button
                        size="sm"
                        className="absolute top-3 right-3 bg-orange-500 hover:bg-orange-600 text-white"
                        onClick={() => copyToClipboard(publisherButtonCode, setCopiedPublisherCode)}
                      >
                        {copiedPublisherCode ? (
                          <>
                            <CheckIcon className="h-4 w-4 mr-2" />
                            Copied!
                          </>
                        ) : (
                          <>
                            <CopyIcon className="h-4 w-4 mr-2" />
                            Copy Code
                          </>
                        )}
                      </Button>
                    </div>
                  </div>
                </div>

                {/* Step 2 - Add to Your Site */}
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <div className="flex items-center justify-center w-8 h-8 rounded-full bg-orange-100 text-orange-600 font-bold text-sm">
                      2
                    </div>
                    <h3 className="text-lg font-semibold text-slate-900">Add to Your Website</h3>
                  </div>
                  
                  <div className="ml-11 grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="p-6 bg-white rounded-xl border border-slate-200 shadow-sm">
                      <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mb-4">
                        <GlobeIcon className="h-6 w-6 text-purple-600" />
                      </div>
                      <h4 className="font-semibold text-slate-900 mb-2">Substack</h4>
                      <p className="text-sm text-slate-600 mb-3">
                        Go to Settings → Publication details → Custom footer
                      </p>
                      <p className="text-xs text-slate-500">
                        Paste the code in the footer HTML section
                      </p>
                    </div>
                    
                    <div className="p-6 bg-white rounded-xl border border-slate-200 shadow-sm">
                      <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                        <CodeIcon className="h-6 w-6 text-blue-600" />
                      </div>
                      <h4 className="font-semibold text-slate-900 mb-2">Custom Site</h4>
                      <p className="text-sm text-slate-600 mb-3">
                        Add the code wherever you want the button
                      </p>
                      <p className="text-xs text-slate-500">
                        Works with WordPress, Medium, Ghost, and any HTML site
                      </p>
                    </div>
                  </div>
                </div>

                {/* Step 3 - How It Works */}
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <div className="flex items-center justify-center w-8 h-8 rounded-full bg-orange-100 text-orange-600 font-bold text-sm">
                      3
                    </div>
                    <h3 className="text-lg font-semibold text-slate-900">How It Works</h3>
                  </div>
                  
                  <div className="ml-11 p-6 bg-blue-50 rounded-xl border border-blue-200">
                    <ol className="space-y-3 text-slate-700">
                      <li className="flex items-start">
                        <span className="text-blue-600 font-bold mr-3 mt-0.5">1.</span>
                        <div>
                          <span className="font-semibold">Reader clicks button</span>
                          <p className="text-sm text-slate-600">They see the "Save to Tickler" button on your article</p>
                        </div>
                      </li>
                      <li className="flex items-start">
                        <span className="text-blue-600 font-bold mr-3 mt-0.5">2.</span>
                        <div>
                          <span className="font-semibold">Authentication (if needed)</span>
                          <p className="text-sm text-slate-600">First-time users log in via secure popup</p>
                        </div>
                      </li>
                      <li className="flex items-start">
                        <span className="text-blue-600 font-bold mr-3 mt-0.5">3.</span>
                        <div>
                          <span className="font-semibold">Auto-saved with AI</span>
                          <p className="text-sm text-slate-600">Article is saved to their Tickler dashboard with AI analysis</p>
                        </div>
                      </li>
                    </ol>
                  </div>
                </div>

                {/* Customization Options */}
                <details className="ml-11 group">
                  <summary className="cursor-pointer text-slate-600 hover:text-slate-900 font-medium flex items-center gap-2">
                    <span>Advanced: Customization Options</span>
                  </summary>
                  <div className="mt-4 p-4 bg-slate-50 rounded-xl border border-slate-200 space-y-4">
                    <div>
                      <p className="text-sm font-semibold text-slate-700 mb-2">Custom URL (for specific article)</p>
                      <code className="block p-3 bg-slate-900 text-green-400 rounded-lg text-xs overflow-x-auto font-mono">
                        {`<a href="#" class="tickler-save-button" data-url="https://yoursite.com/article" data-title="Article Title">Save to Tickler</a>`}
                      </code>
                    </div>
                    
                    <div>
                      <p className="text-sm font-semibold text-slate-700 mb-2">Custom button text</p>
                      <code className="block p-3 bg-slate-900 text-green-400 rounded-lg text-xs overflow-x-auto font-mono">
                        {`<a href="#" class="tickler-save-button">📄 Save for Later</a>`}
                      </code>
                    </div>
                    
                    <div>
                      <p className="text-sm font-semibold text-slate-700 mb-2">Multiple buttons on same page</p>
                      <code className="block p-3 bg-slate-900 text-green-400 rounded-lg text-xs overflow-x-auto font-mono">
                        {`<!-- Script loads once, add buttons anywhere -->
<a href="#" class="tickler-save-button">Save Article</a>
<a href="#" class="tickler-save-button">Save for Research</a>`}
                      </code>
                    </div>
                  </div>
                </details>

                {/* Benefits Section */}
                <div className="p-6 bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl border border-green-200">
                  <h4 className="font-semibold text-green-900 mb-3 flex items-center">
                    <SparklesIcon className="h-5 w-5 mr-2" />
                    Why Add This Button?
                  </h4>
                  <ul className="space-y-2 text-green-800 text-sm">
                    <li>• <strong>Increase engagement:</strong> Readers can save your content for later</li>
                    <li>• <strong>Build loyalty:</strong> Your articles appear in their investment dashboard</li>
                    <li>• <strong>Professional branding:</strong> Shows you're part of the investment community</li>
                    <li>• <strong>Zero maintenance:</strong> Works automatically with no updates needed</li>
                  </ul>
                </div>
              </CardContent>
            </Card>
          </TabsContent>

          {/* Browser Extension Tab */}
          <TabsContent value="extension">
            <Card className="border-0 shadow-xl bg-white/50 backdrop-blur">
              <CardHeader className="border-b border-slate-100 pb-6">
                <CardTitle className="flex items-center text-2xl">
                  <div className="bg-gradient-to-br from-blue-500 to-blue-600 p-2 rounded-lg mr-3">
                    <ChromeIcon className="h-6 w-6 text-white" />
                  </div>
                  Chrome Extension
                </CardTitle>
                <p className="text-slate-600 mt-2">Browser integration • Right-click to save • Desktop only</p>
              </CardHeader>
              <CardContent className="space-y-6 pt-8">
                <Alert className="border-blue-200 bg-blue-50">
                  <AlertDescription className="text-blue-900">
                    <strong>Chrome & Edge users:</strong> Get seamless integration with a dedicated extension
                  </AlertDescription>
                </Alert>

                <div className="space-y-6">
                  <div>
                    <h3 className="text-lg font-semibold text-slate-900 mb-3">Installation</h3>
                    <ol className="space-y-4">
                      <li className="flex gap-4">
                        <span className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 text-blue-600 font-bold text-sm flex-shrink-0">
                          1
                        </span>
                        <div className="flex-1">
                          <p className="text-slate-700 mb-2">Download the extension</p>
                          <a
                            href="/api/chrome-extension-download"
                            download="tickler-extension.html"
                            className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl hover:scale-105 transition-all"
                          >
                            <ExternalLinkIcon className="h-5 w-5 mr-2" />
                            Download Extension
                          </a>
                        </div>
                      </li>
                      <li className="flex gap-4">
                        <span className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 text-blue-600 font-bold text-sm flex-shrink-0">
                          2
                        </span>
                        <div className="flex-1">
                          <p className="text-slate-700 mb-2">Open Chrome Extensions</p>
                          <p className="text-sm text-slate-600">Navigate to <code className="px-2 py-1 bg-slate-100 rounded">chrome://extensions</code></p>
                        </div>
                      </li>
                      <li className="flex gap-4">
                        <span className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 text-blue-600 font-bold text-sm flex-shrink-0">
                          3
                        </span>
                        <div className="flex-1">
                          <p className="text-slate-700 mb-2">Enable Developer Mode</p>
                          <p className="text-sm text-slate-600">Toggle the switch in the top-right corner</p>
                        </div>
                      </li>
                      <li className="flex gap-4">
                        <span className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 text-blue-600 font-bold text-sm flex-shrink-0">
                          4
                        </span>
                        <div className="flex-1">
                          <p className="text-slate-700 mb-2">Drag and drop the downloaded file</p>
                          <p className="text-sm text-slate-600">Drop it onto the extensions page to install</p>
                        </div>
                      </li>
                    </ol>
                  </div>

                  <div className="p-6 bg-green-50 rounded-xl border border-green-200">
                    <h4 className="font-semibold text-green-900 mb-2">Usage</h4>
                    <p className="text-green-800">
                      Once installed, right-click on any webpage and select "Save to Tickler" from the context menu
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </TabsContent>

          {/* Email Tab */}
          <TabsContent value="email">
            <Card className="border-0 shadow-xl bg-white/50 backdrop-blur">
              <CardHeader className="border-b border-slate-100 pb-6">
                <CardTitle className="flex items-center text-2xl">
                  <div className="bg-gradient-to-br from-purple-500 to-purple-600 p-2 rounded-lg mr-3">
                    <MailIcon className="h-6 w-6 text-white" />
                  </div>
                  Email Forwarding
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-6 pt-8">
                <Alert className="border-purple-200 bg-purple-50">
                  <AlertDescription className="text-purple-900">
                    <strong>Perfect for:</strong> Saving investment newsletters, research reports, and email insights
                  </AlertDescription>
                </Alert>

                <div className="space-y-6">
                  <div>
                    <h3 className="text-lg font-semibold text-slate-900 mb-3">Your Personal Tickler Email</h3>
                    <div className="p-6 bg-gradient-to-br from-slate-50 to-slate-100 rounded-xl border-2 border-slate-200">
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="text-sm text-slate-600 mb-2">Forward emails to:</p>
                          <code className="text-lg font-mono font-bold text-slate-900 bg-white px-4 py-2 rounded-lg border border-slate-300 inline-block">
                            {ticklerEmail}
                          </code>
                        </div>
                        <Button
                          onClick={() => copyToClipboard(ticklerEmail, setCopiedEmail)}
                          className="bg-purple-500 hover:bg-purple-600 text-white"
                        >
                          {copiedEmail ? <CheckIcon className="h-5 w-5 mr-2" /> : <CopyIcon className="h-5 w-5 mr-2" />}
                          {copiedEmail ? 'Copied!' : 'Copy'}
                        </Button>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-lg font-semibold text-slate-900 mb-3">How It Works</h3>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <div className="p-6 bg-white rounded-xl border border-slate-200 shadow-sm">
                        <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mb-4">
                          <MailIcon className="h-6 w-6 text-purple-600" />
                        </div>
                        <h4 className="font-semibold text-slate-900 mb-2">1. Forward</h4>
                        <p className="text-sm text-slate-600">
                          Forward any investment email to your Tickler address
                        </p>
                      </div>
                      <div className="p-6 bg-white rounded-xl border border-slate-200 shadow-sm">
                        <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mb-4">
                          <SparklesIcon className="h-6 w-6 text-purple-600" />
                        </div>
                        <h4 className="font-semibold text-slate-900 mb-2">2. AI Analyzes</h4>
                        <p className="text-sm text-slate-600">
                          Our AI extracts tickers and key insights automatically
                        </p>
                      </div>
                      <div className="p-6 bg-white rounded-xl border border-slate-200 shadow-sm">
                        <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mb-4">
                          <BookmarkIcon className="h-6 w-6 text-purple-600" />
                        </div>
                        <h4 className="font-semibold text-slate-900 mb-2">3. Organized</h4>
                        <p className="text-sm text-slate-600">
                          Ideas appear in your dashboard, ready for action
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="p-6 bg-amber-50 rounded-xl border border-amber-200">
                    <h4 className="font-semibold text-amber-900 mb-2 flex items-center">
                      <SparklesIcon className="h-5 w-5 mr-2" />
                      Pro Tips
                    </h4>
                    <ul className="space-y-2 text-amber-800 text-sm">
                      <li>• Works great with investment newsletters from Substack, Seeking Alpha, and more</li>
                      <li>• Add your Tickler email to your contacts for easy forwarding</li>
                      <li>• Forward from mobile devices – no app installation needed</li>
                    </ul>
                  </div>
                </div>
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </div>

      {/* Footer */}
      <footer className="border-t border-slate-200 mt-20 py-8 bg-white/50">
        <div className="max-w-6xl mx-auto px-6 text-center text-slate-600 text-sm">
          <p>Need help? Check our <a href="#" className="text-orange-500 hover:text-orange-600 font-medium">documentation</a> or <a href="#" className="text-orange-500 hover:text-orange-600 font-medium">contact support</a></p>
        </div>
      </footer>

      {/* Bookmarklet Installation Modal using Portal */}
      {showBookmarkletModal && ReactDOM.createPortal(
        <BookmarkletModal 
          userId={userId}
          userEmail={userEmail}
          apiUrl={API_BASE_URL}
          onClose={() => setShowBookmarkletModal(false)}
        />,
        document.body
      )}

      {/* Bookmarklet 2 Modal - BRAND NEW */}
      {showBookmarklet2Modal && ReactDOM.createPortal(
        <Bookmarklet2Modal 
          userId={userId}
          userEmail={userEmail}
          apiUrl={API_BASE_URL}
          onClose={() => setShowBookmarklet2Modal(false)}
        />,
        document.body
      )}
    </div>
  );
}

export default SaveMethodsPage;